import React from 'react';
import { ArrowDownTrayIcon, CalculatorIcon, EyeIcon } from '@heroicons/react/24/outline';
import { Button, Card } from '../ui';

const GroupsMatchedSummary = ({
  groupsCount,
  hasActiveFilters,
  isLoadingCount,
  showGroups,
  onShowGroupsToggle,
  onExport,
  isExporting,
  canExport,
}) => {
  return (
    <Card>
      <div className="p-4">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <CalculatorIcon className="h-5 w-5 text-gray-500" />
              <span className="text-sm font-medium text-gray-800">
                {isLoadingCount
                  ? 'Подсчет...'
                  : `Matched groups: ${groupsCount.toLocaleString()}`}
              </span>
              {hasActiveFilters && (
                <span className="rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700">
                  filtered set
                </span>
              )}
            </div>
            <p className="mt-2 text-xs text-gray-500">
              Language/region metadata is incomplete and stored as raw values from the database.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            <Button
              variant="secondary"
              size="sm"
              icon={EyeIcon}
              onClick={onShowGroupsToggle}
              disabled={groupsCount === 0}
            >
              {showGroups ? 'Hide groups' : 'Show groups'}
            </Button>
            <Button
              variant="primary"
              size="sm"
              icon={ArrowDownTrayIcon}
              onClick={onExport}
              isLoading={isExporting}
              disabled={!canExport}
            >
              Export filtered groups
            </Button>
          </div>
        </div>

        {!hasActiveFilters && (
          <div className="mt-4 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
            Add at least one filter or search term before exporting or running filtered bulk actions.
          </div>
        )}
      </div>
    </Card>
  );
};

export default GroupsMatchedSummary;
